import React from 'react'
import { connect } from 'react-redux'
import { startOfDay } from 'date-fns'
// Local
import { getBaseAppUrl } from '../../config'
import {
  PAGES,
  ROLES
} from '../../constant'
import AdminWelcome from '../admin/AdminWelcome'
import CdiWorklist from '../worklist/cdi/cdiWorklist'
import ClinicalAdminWorklist from '../worklist/clinicalAdmin/clinicalAdminWorklist'
import CoderWorklist from '../worklist/coder/coderWorklist'
import PhysicianWorklist from '../worklist/physician/PhysicianWorklist'
// Styling
import './index.css'

type RootState = {
  user: {
    type: string
    userId: string
    username: string
  }
  encounter: {
    physicianDay: Date | null
  }
}

type HomeProps = {
  match: {
    params: {
      date?: string
    }
  }
  history: {
    push: (path: string) => void
  }
  type: string
  userId: string
}

/**
 * Provides the top-level Home component. Determines which work list to display
 * based on current user role, handles encounter select from the work list
 */
function Home(
  props: HomeProps
): JSX.Element | null {
  const {
    match,
    history,
    type,
    userId
  } = props

  const onEncounterSelect = (id: string, event?: React.MouseEvent) => {
    const route = `${PAGES.ENCOUNTER_DETAIL}${id}`
    if (event && (event.metaKey || event.ctrlKey)) {
      const newWindow = window.open(getBaseAppUrl() + route, '_blank')
      if (newWindow) {
        newWindow.focus()
      }
    } else {
      history.push(route)
    }
  }

  const dateParam = match.params.date
  const startDate = dateParam
    ? startOfDay(new Date(dateParam))
    : startOfDay(new Date())
  const userRole = type

  if (userRole === ROLES.CLINICAL_ADMIN) {
    return (
      <ClinicalAdminWorklist onSelect={ onEncounterSelect } />
    )
  }

  if (userRole === ROLES.PHYSICIAN) {
    return (
      <PhysicianWorklist
        practitionerId={ userId }
        onSelect={ onEncounterSelect }
        viewDate={ startDate }
      />
    )
  }

  if (ROLES.isCdi(userRole)) {
    return (
      <CdiWorklist
        onSelect={ onEncounterSelect }
      />
    )
  }

  if (userRole === ROLES.CODER || userRole === ROLES.CODER_QA_MANAGER) {
    return (
      <CoderWorklist
        onSelect={ onEncounterSelect }
        userRole={ userRole }
      />
    )
  }

  if (userRole === ROLES.ADMIN) {
    return (
      <AdminWelcome />
    )
  }

  return null
}

export default connect(
  (state: RootState) => ({
    type: state.user.type,
    userId: state.user.userId
  }),
  {}
)(Home)
